import React, { useEffect, useState } from "react";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { smsdatalist } from "../../../services/common";
import { roleList } from "../../../services/master";
export default function ListSms() {
    const [filterProduct, setFilterProduct] = useState([]);
    const [loading, setLoading] = useState(false);

    function listall() {
        setLoading(true);
        setFilterProduct([]);

        smsdatalist().then((res) => {
            if (res.status === true) {
                 roleList().then((res1) => {
                    if (res1.status === true) {
                        const roles = res1.data;
                        const updatedData = res.data
                            .filter((item) => item.audio == null) // text SMS only — audio shown under Notification List
                            .map((item) => {
                            return {
                                ...item,
                                role_name: roles.find((role) => role.id == item.role)?.name || "",
                                
                            };
                        });
                        setFilterProduct(updatedData);
                    }
                });
                setLoading(false);
            }
        });
       
    }

    useEffect(() => {
        listall();
    }, []);

    const columnDefs = [
        {
            headerName: "Date",
            field: "created_at",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            valueFormatter: (params) => moment(params.value).format("DD-MM-YYYY"),
        },
        {
            headerName: "Time",
            field: "created_at",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            valueFormatter: (params) => moment(params.value).format("hh:mm A"),
        },
        {
            headerName: "Message",
            field: "message",
            width: 300,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            // tooltipField: "message",
            cellStyle: { textAlign: "left" },
            cellRenderer: (params) => {

                if (params.data.audio != null) {
                    return (<audio controls>
                        <source src={params.data.audio} type="audio/webm" />
                        Your browser does not support audio.
                    </audio>
                    );
                } else {
                    return params.value;
                }
            }
        },
        {
            headerName: "Message Sent To",
            field: "role_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
           
        },

      
    ];

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5"> SMS List</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Communication </a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {" "}
                        SMS List
                    </li>
                </ol>
            </div>
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="container">
                    <div className="ag-theme-alpine ag-style mt-2">
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={filterProduct}
                            pagination="true"
                            paginationPageSize="10"
                            sortingOrder={["asc", "desc"]}
                            suppressDragLeaveHidesColumns={true}
                        />
                    </div>
                </div>
            )

            }


        </div>
    );
}
